export const API_URI = {
  DEF_RATE_FOR_CH_ORD: "DefineRateForCharter",
  CH_BOOK: "SaveChartedShipment",
  DYN_ROUTE: "DynamicRoutes",
  CFM_CH_RATE: "ConfirmServiceValue",
  GET_CUST_CH_RATE_CONFIG: "GetCustChRateConfig",
  SYS_OPTION_BY_CODE: "SysOptionGetByCode",
  GET_CH_ORD_DTLS: "GetOrderDetails",
  GET_CUST_CREDIT_INFO: "GetCustCreditInfo",
};
